import React from 'react';
import { useOutletContext } from 'react-router-dom';
import {
    formatCurrencyValue,
    getFullPaymentAmountText,
    getPartialPaymentAmountText
} from 'ts/common/components/invoice/helpers';
import { useTranslate } from 'ts/common/hooks';
import { type ClientPaymentOption } from 'client_react/common/components/ClientPaymentOptions';
import ClientPaymentSummary from 'client_react/common/components/ClientPaymentSummary';

interface Props {
    paymentAmountType: ClientPaymentOption;
}

const InvoicePaymentSummary = ({ paymentAmountType }: Props) => {
    const { invoice } = useOutletContext<{ invoice: SpApi.Client.IInvoice }>();
    const t = useTranslate('clientInvoice');

    const fullPaymentAmountText = getFullPaymentAmountText(invoice);
    const partialPaymentAmountText = getPartialPaymentAmountText(invoice);

    return (
        <ClientPaymentSummary
            showBreakdown={
                (Number(invoice.salesTaxTotal) > 0 || Number(invoice.discountTotal) > 0) &&
                paymentAmountType === 'full' &&
                invoice.dueTotal === invoice.grandTotal
            }
            discounts={formatCurrencyValue(Number(invoice.discountTotal), invoice.currencyCode)}
            discountsSubtitle={t('discounts')}
            salesTax={formatCurrencyValue(Number(invoice.salesTaxTotal), invoice.currencyCode)}
            salesTaxSubtitle={t('paymentSummaryTax')}
            subtotal={formatCurrencyValue(Number(invoice.subtotal), invoice.currencyCode)}
            subtotalSubtitle={t('paymentSummarySubtotal')}
            title={t('paymentSummary')}
            totalPrice={
                paymentAmountType === 'full' ? fullPaymentAmountText : partialPaymentAmountText
            }
            totalSubtitle={t('paymentSummaryTotal')}
        />
    );
};

export default InvoicePaymentSummary;
